var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import MUIPaper from '@material-ui/core/Paper';
import cn from 'classnames';
import withThemeSelector from '../withThemeSelector';
import useStyles from './Paper.styles';
export const Paper = (_a) => {
    var { elevation = 0, className, children } = _a, paperProps = __rest(_a, ["elevation", "className", "children"]);
    const classes = useStyles();
    return (_jsx(MUIPaper, Object.assign({ className: cn(classes.root, className), elevation: elevation }, paperProps, { children: children })));
};
export default withThemeSelector(Paper);
//# sourceMappingURL=Paper.js.map